import { lazy } from 'react';

const RELOAD_KEY = 'sahiri_chunk_reloaded';

/** React.lazy that survives a deploy: a missing/renamed chunk triggers ONE page reload instead of a blank screen. */
export function lazyRetry(importer) {
  return lazy(() =>
    importer()
      .then((mod) => { try { sessionStorage.removeItem(RELOAD_KEY); } catch { /* private mode */ } return mod; })
      .catch((err) => {
        let reloaded = false;
        try { reloaded = sessionStorage.getItem(RELOAD_KEY) === '1'; } catch { /* private mode */ }
        if (!reloaded && typeof window !== 'undefined' && navigator.onLine !== false) {
          try { sessionStorage.setItem(RELOAD_KEY, '1'); } catch { /* private mode */ }
          window.location.reload();
          return new Promise(() => {});
        }
        throw err;
      }),
  );
}

/** Warm a chunk in the background (ignores failures — it is only a hint). */
export function prefetch(importer) {
  try { importer().catch(() => {}); } catch { /* ignore */ }
}

/** Run `fn` when the browser is idle (or after `timeout` ms), returning a cancel function. */
export function whenIdle(fn, timeout = 2000) {
  if (typeof window === 'undefined') return () => {};
  if ('requestIdleCallback' in window) {
    const id = window.requestIdleCallback(fn, { timeout });
    return () => window.cancelIdleCallback(id);
  }
  const id = setTimeout(fn, Math.min(timeout, 1200));
  return () => clearTimeout(id);
}
